module.exports = __webpack_public_path__ + "static/img/aboutUse.de2cdcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUse.png
// module id = 3qFS
// module chunks = 1